import { render } from "./CreateSummary.vue?vue&type=template&id=c40110b6"
import script from "./CreateSummary.vue?vue&type=script&lang=js"
export * from "./CreateSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__